<template>
<div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page header -->
	    <page-heading :show="true" pageTitle="HEADER-CATALOG" :pageTitle2="pageTitle"></page-heading>

		<div class="columns">

			<div class="col-main">

				<!-- status -->
				<div class="control">
					<div class="control-label">
						<label-name labelKey="PAGE-STATUS"></label-name>
					</div>
					<div class="control">

						<status-dropdown type="pageStatus" label="SELECT_BOX-STATUS_" :data.sync="catalogPage.status"></status-dropdown>

						<!--
						<span class="select is-normal">

							<select id="PAGE-STATUS" v-model="catalogPage.status" :class="[catalogPage.status.name, 'statusSelector']">
								<option :value="null">{{ $t('SELECT_BOX-STATUS_SELECT_STATUS') }}</option>

								<template v-for="status in pageStatus">

									<template v-if="userRole=='Redaktion'">
										<template v-if="status.name == 'READY' || status.name == 'EDITED'">
											<option :value="status" :class="status.name">
												{{ $t('SELECT_BOX-STATUS_' + status.name) }}
											</option>
										</template>
									</template>

									<template v-else>
										<option :value="status" :class="status.name">
											{{ $t('SELECT_BOX-STATUS_' + status.name) }}
										</option>
									</template>

								</template>

							</select>
						</span>
						-->

					</div>

				</div>


				<div id="pagesWrapper" class="pageStatus" :class="catalogPage.status ? catalogPage.status.name : ''">

					<div :class="[specialPageType, 'rectangle-box detailed']">

		                <div class="rectangle-content">

		                    <div class="columns">

								<!-- FRONT or BACK -->
								<template v-if="specialPageType == 'front' || specialPageType == 'back'">

									<div class="column is-6" v-if="specialPageType == 'front'"></div>

									<div class="column is-6 pointer" @click="goToDetail()">
										<content-rich-text :data="catalogPage.catalogPageElements[0]" :settings="{width:100}"></content-rich-text>
									</div>

									<div class="column is-6" v-if="specialPageType == 'back'"></div>

								</template>

								<!-- BOOKMARK -->
								<template v-else-if="specialPageType == 'bookmark'">

									<div class="column is-6"></div>

									<div class="column is-3 is-narrow content pointer" @click="goToDetail()">
										<content-rich-text :data="catalogPage.catalogPageElements[0]" :settings="{width:100}"></content-rich-text>
									</div>

									<div class="column"></div>

								</template>

		                    </div>

		                </div> <!-- END rectangle-content -->

		            </div> <!-- END rectangle-box -->

				</div> <!-- // #pagesWrapper -->

				<!-- COMMENTS -->
				<comments headerTitle="CATALOG-PAGE-HEADER_COMMENTS" :threadID.sync="catalogPage.thread" :api="'catalogPage/'+catalogPage.id"></comments>


			</div> <!-- // col-main -->


	        <div class="col-aside">

				<affix :offset="50">

					<div class="sidebox">

					<template v-if="userRole != 'Redaktion'">
						<custom-button type="blue" icon="icon-ak-speichern" name="PAGE_BUTTON-SAVE" :loading="isSaving" @click.native="formSubmit({ isSilent: false })"></custom-button>
					</template>

					</div>

					<div class="sidebox" v-if="userRole != 'Redaktion'">

						<div class="heading">Preview</div>

						<vue-dropzone
	                        ref="vueDropzone"
	                        id="vueDropzone"
	                        url= "fileProcessing/upload?preset=catalogPage"
							:formDataAppend = "[{'catalogPage': catalogPage.id}]"
	                        :maxFiles="1"
	                        :clickable="true"
	                        dictDefaultMessage = "<i class='fa fa-cloud-upload'></i>Preview upload"
	                        v-on:vdropzone-mounted="dzInit"
	                        v-on:vdropzone-drop="dzDrop"
	                        v-on:vdropzone-success="dzSuccess($event)"
	                        v-on:vdropzone-removed-file="dzRemoveFile"
	                        dzClass="dzSingle">
	                    </vue-dropzone>

					</div>


					<div class="sidebox" v-if="catalogPage.preview != null">
						<a :href="downloadURL" :download="catalogPage.preview.uploadFilename" class="button is-light">
							<span class="icon is-small"><i class="icon-ak-download"></i></span>
							{{ $t("BTN-CATALOG_PAGES-DOWNLOAD_PDF")}}
						</a>
					</div>

					<!--
					<div class="sidebox" v-if="userRole == 'Administrator'">
						<div class="heading">Online Katalog</div>
						<crop-image name="onlineCatalog" :pages.sync="catalogPage" v-on:save="formSubmit"></crop-image>
					</div>
					-->

				</affix>

	        </div>

	    </div>


	</template>

</div>

</template>



<script>
import contentRichText from './contentElements/contentElementRichText';
import vueDropzone from '../utils/dropzoneWrapper'
import comments from '../utils/incl-comments';
import statusDropdown from '../utils/incl-statusDropdown'


export default {

	name: 'catalogPageSpecial',

	components: {
		comments,
		vueDropzone,
		contentRichText,
		statusDropdown
	},

	data() {
		return {
			catalogPage: {},
			isLoading: true,
			isSaving: false,
        }
    },


	computed: {

		downloadURL() {
			var asset = this.$config.assets + this.catalogPage.preview.path + '/' + this.catalogPage.preview.filename;
			return asset;
		},

		pageStatus() {
			return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_STATUS');
		},

		specialPageType() {
			return this.$route.params.type;
		},

		pageTitle() {

			switch(this.specialPageType) {
				case "front":
					return "Cover Front";
				case "back":
					return "Cover U4";
				case "bookmark":
					return "Lesezeichen";
			}
		}

	},

	created() {

		// EXISTING PAGE
		if(this.$route.params.pageID && Number.isInteger(parseInt(this.$route.params.pageID)))
		{
			this.fetchData();
		}

	},

    mounted() {


    },

	updated() {


	},


    methods: {


		goToDetail() {

			this.$router.push('/katalog/pageElement-' + this.catalogPage.catalogPageElements[0].id);

		},

		getPreviewURL(preview) {

			if(this.specialPageType != 'bookmark') {

				return this.$config.assets + preview.path + '/' + preview.filename + '.png';

			} else {

				// as a "lesezeichen" has 2 pages and therefore generates 2 images, we
				// return this first one only (*.*-0.png)
				return this.$config.assets + preview.path + '/' + preview.filename + '-0.png';

			}

		},


		dzInit() {

			if(this.catalogPage.preview) {

				// empty our dropzone first
				this.$refs.vueDropzone.$children[0].removeAllFiles();

				var url = this.getPreviewURL(this.catalogPage.preview);
				var mockFile = { id: 'previewImage', name: this.catalogPage.preview.filename, type: "image/*", size: 123 }

				// add mockFile to our dropzone
				this.$refs.vueDropzone.$children[0].manuallyAddFile(mockFile, url);

			}

		},

		dzSuccess(file) {

			var result = JSON.parse(file.xhr.response);

			this.catalogPage.preview = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			this.dzInit();

		},

		dzRemoveFile(file, error, xhr) {

			// if file object doesn't have a "size" property,
			// dzRemoveFile() was called via dzRemoveFile() from the dropzone options
			// -> we remove the preview property
			if(!file.size) {
				this.catalogPage.preview = null;
			}

			this.formSubmit({isSilent: false});

		},


		formSubmit(options) {

			if(options && !options.isSilent) {
				this.isSaving = true;
			}

			var self = this;

			this.axios.post(this.$config.api + 'catalogPage/'+this.catalogPage.id, this.catalogPage)
				.then(function(response) {

					if(!options.isSilent) {
						self.$notify.success({content: self.$t("MSG-SUCCESS-DATA_SAVE")});
					}

					self.isSaving = false;

				}).catch(function(error) {
					console.log('Error: ', error.message);
					self.isSaving = false;
				});

		},


		fetchData() {

			this.isLoading = true;
            var self = this;

            // fetch data
			this.axios.get(self.$config.api + 'catalogPage/'+this.$route.params.pageID+'?include=catalogPageElement.contentElement,contentElement.type,catalogPage.pageLayout,contentElement.contentElementData,catalogPage.catalogPageElements,catalogPage.status,catalogPageElement.status,contentElementData.assets,contentElementDataAsset.asset,catalogPage.preview,catalogPage.catalogPageVariants,catalogPageVariant.status,catalogPageVariant.preview')

				.then(function(response) {

					self.catalogPage = response.data;

					// make sure the page has a status
					if(self.catalogPage.status == null) {
						self.catalogPage.status = self.pageStatus.CREATED;
					}

	    			self.isLoading = false;

                }).catch(function(error) {
                    console.log('Error: ', error.message);
                    self.isLoading = false;
                });

		},


    }

}

</script>


<style lang="scss" scoped>

    @import '../../assets/css/variables.scss';

	#pagesWrapper.pageStatus.CREATED {
		border-top-color: $statusCreated !important;
	}
	#pagesWrapper.pageStatus.READY {
		border-top-color: $statusReady !important;
	}
	#pagesWrapper.pageStatus.EDITED {
		border-top-color: $statusEdited !important;
	}
	#pagesWrapper.pageStatus.LAYOUTED {
		border-top-color: $statusLayouted !important;
	}
	#pagesWrapper.pageStatus.REVISED {
		border-top-color: $statusRevised !important;
	}
	#pagesWrapper.pageStatus.APPROVED {
		border-top-color: $statusApproved !important;
	}
	#pagesWrapper.pageStatus.PRINT_APPROVED {
		border-top-color: $statusPrintApproved !important;
	}
	#pagesWrapper.pageStatus.REVIEW {
		border-top-color: $statusReview !important;
	}

	.variantStatus-DEFAULT {
		background: $statusCreated !important;
	}
	.variantStatus-SELECTED {
		background: $statusApproved !important;
	}
	.variantStatus-APPROVED {
		background: $statusPrintApproved !important;
	}

</style>


<style scoped>

	.column.is-6 .box {
		width: 60%;
		height: 0;
		padding-bottom: 60%;
	}

	.col-main {
		margin-bottom: 40px;
	}
	#pagesWrapper {
		background: #fff;
		padding: 30px;
		margin: 20px 0 0 0;
		min-width: 700px;
		border-top: 10px solid transparent;
	}

    /* RECTANGLE BOX (columns wrapper)*/
    .rectangle-box {
        position: relative;
        width: 100%;
        max-width: 1300px;
        padding: 0;
        margin: 0 auto;
        background: transparent url('../../assets/img/bg-pages.jpg') no-repeat 45% 12%;
        background-size: 98%;
    }
	.rectangle-box:before {
        content: "";
        display: block;
        padding-top: 47%;
    }

	.rectangle-box.front {
        position: relative;
        width: 100%;
        max-width: 1300px;
        padding: 0;
        margin: 0 auto;
        background: transparent url('../../assets/img/bg-pages-front.jpg') no-repeat 45% 12%;
        background-size: 98%;
    }
    .rectangle-box.back {
        position: relative;
        width: 100%;
        max-width: 1300px;
        padding: 0;
        margin: 0 auto;
        background: transparent url('../../assets/img/bg-pages-u4.jpg') no-repeat 45% 12%;
        background-size: 98%;
    }
	.rectangle-box.bookmark {
        position: relative;
        width: 100%;
        max-width: 1300px;
        padding: 0;
        margin: 0 auto;
        background: transparent url('../../assets/img/bg-pages-bookmark.jpg') no-repeat 45% 12%;
        background-size: 98%;
    }



	.rectangle-content {
        position: absolute;
        top: 3.4%;
        left: 2.1%;
        right: 2.7%;
        bottom: 5%;
    }
	.rectangle-box.bookmark .rectangle-content {
	    top: 7%;
	    left: 2%;
	    right: 2.7%;
	    bottom: 11%;
    }


	.rectangle-box.bookmark .is-3.is-narrow {
		width: 22%;
	}






    /* PAGE LAYOUT COLUMNS */
    .rectangle-content > .columns {
        position: absolute;
        right: 1% !important;
        left: 1% !important;
        top: 1% !important;
        bottom: 1%;
        padding: 0 !important;
        margin: 0 !important;
    }
    .rectangle-content > .columns .column {
        margin: 0 !important;
        padding: .8% !important;
        position: relative !important;
        overflow: hidden;
        height: 100%;
    }
    .rectangle-content > .columns > .column > div.inner {
        position: relative;
        padding: 0 !important;
        margin: 0 !important;
        border: 1px dotted #ccc;
        transition: background .3s ease, border-color .3s ease;
        font-size: 0.8vw;
        cursor: pointer;
        height: 100%;
    }
    .rectangle-content > .columns .column > div.inner:hover {
        border: 1px dotted #000;
    }

    /* columns which already have a content element set should get another border */
    .rectangle-content > .columns > .column > div.inner[class*="pageElementType"] {
        border: 1px solid rgba(150,150,150,0.2);
    }
    .rectangle-content > .columns > .column > div.inner[class*="pageElementType"]:hover {
        border: 1px solid rgba(150,150,150,0.8);
    }
    .rectangle-box.detailed .contentPageElement {
        background: #fff !important;
        overflow: hidden;
    }

</style>
